import {
    COMMON_TOAST, COMMON_TOAST_HIDE, COMMON_TOAST_RESET,
} from './constants';

export const commonToast = ({message, errorMessage, successMessage, errorCode}) => ({
    type: COMMON_TOAST,
    payload: {message,  errorMessage, successMessage, errorCode},
});

export const commonToastReset = () => ({
    type: COMMON_TOAST_RESET,
    payload: null,
});

export const commonToastHide = () => ({
    type: COMMON_TOAST_HIDE,
    payload: null,
});
